// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M12.0001 7.5L19 14.5L5 14.5L12.0001 7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"caret-up"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.0001 7.5L19 14.5L5 14.5L12.0001 7.5Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0001 7.5L19 14.5L5 14.5L12.0001 7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CaretUpIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'caret-up',
    ref,
    icon: element,
  },
));

CaretUpIcon.displayName = 'CaretUpIcon';

export default CaretUpIcon;
